import addStartupScript from '../events/addStartupScript';

const cssClasses = {
  subnavButtonVisible: 'js-subnav-items__button--visible',
};
const selectors = {
  leadForm: '.leadform',
  subnavButton: '.js-subnav-items__button',
  subnavButtonSecondary: '.button--secondary.js-subnav-items__button',
};

const fadeInElement = function (button) {
  button?.classList?.add(cssClasses.subnavButtonVisible);
};

const fadeOutElement = function (button) {
  button?.classList?.remove(cssClasses.subnavButtonVisible);
};

const useObserver = function (
  observedElement,
  elementsToFadeIn,
  elementsToFadeOut
) {
  const options = {
    root: null, // observe `observedElement` relative to document viewport
    rootMargin: '-62px', // set the intersection window 62px below top of viewport ($header-height)
    threshold: [0, 0.5], // wait for this portion of `observedElement` to be visible in viewport before triggering the fade-in
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(function (entry) {
      if (entry.intersectionRatio === 0) {
        elementsToFadeIn.forEach((elem) => fadeInElement(elem));
      } else if (entry.intersectionRatio >= 0.5) {
        elementsToFadeOut.forEach((elem) => fadeOutElement(elem));
      }
    });
  }, options);

  observer.observe(observedElement);
};

export function setupFade() {
  const observedElement = document.querySelector(selectors.leadForm);
  const elementsToFadeIn = Array.from(
    document.querySelectorAll(selectors.subnavButton)
  );
  const secondaryButton = document.querySelector(
    selectors.subnavButtonSecondary
  );
  const elementsToFadeOut = secondaryButton ? [secondaryButton] : [];

  if (observedElement && elementsToFadeIn.length > 0) {
    // additional check against undefined is required for testing (has no effect on browser)
    // due to this bug: https://github.com/facebook/jest/issues/3152
    if (
      'IntersectionObserver' in window &&
      window.IntersectionObserver !== undefined
    ) {
      useObserver(observedElement, elementsToFadeIn, elementsToFadeOut);
    } else {
      elementsToFadeIn.forEach((elem) => fadeInElement(elem));
    }
  }
}

addStartupScript(setupFade);
